import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import Code from 'components/Code';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoLicence extends Component {

    render() {
        const { licence } = this.props;
        const summary = getTitleSummary(licence)
        return (
            <CodeInfoSection
                title={{
                    headers: ['Лицензии и запреты'],
                    rows: summary
                }}
                expanded={(licence.length !== 0) ? true : false}
                table={{
                    headers: [
                        '',
                        'Код',
                        'Описание',
                        'Тип',
                        'Нормативный документ'
                    ],
                    rows: licence.map(({ to_date = null, code = '', description = '', type_dsc = '',
                        order, order_date, orders_info }) => ([
                            <ToDateNotificator to_date={to_date} />,
                            <Code code={code} />,
                            description,
                            type_dsc,
                            formatOrder(order, order_date, orders_info)
                        ]))
                }}
            />
        );
    }
}

function getTitleSummary(items) {
    return items.length !== 0 ? [['есть']] : null;
}




// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoLicence.js